import InformationOutlineIcon from "mdi-react/InformationOutlineIcon";
import machineFallbackImage from "assets/Svgs/no-machine.jpg";
import { hasMalfunction } from "../shared-functions/notification";
import IconText from "./IconText";
import "./MachineCardItem.css";
import i18n from "i18n/i18n";
import { useBoundStore } from "store/store";
import { truncateWithEllipses } from "utils/helper";
import { Tooltip } from "@mui/material";

const MachineCardItem2 = (props: any) => {
  const lang: any = useBoundStore((state) => state.lang);

  const equipmentData = props.data.equipment;
  const machineHasMalfunction = hasMalfunction(equipmentData.hasnotification);

  let hasMachineImage =
    equipmentData.image != null &&
    equipmentData.image.fileid !== "" &&
    Object.keys(equipmentData.image).length !== 0;

  const cardImageUrl = hasMachineImage
    ? equipmentData.image.url
    : machineFallbackImage;

  return (
    <>
      <div className="machineCardItemWrapper">
        <div className="imageWrapper">
          <div
            style={{
              backgroundImage: "url(" + cardImageUrl + ")",
              backgroundSize: hasMachineImage ? "contain" :"cover"
            }}
            className="image"
          ></div>
        </div>
        <div className="contentWrapper">
          <div
            className="border"
            style={{ borderTopColor: machineHasMalfunction }}
          ></div>
          <div className="content" style={{ paddingTop: "9%" }}>
            <div className="title" style={{ marginBottom: "0px" }}>
              <Tooltip title={equipmentData.name}>
                <div>{truncateWithEllipses(equipmentData.name, 30)} </div>
              </Tooltip>
            </div>
            <div className="desc">
              {equipmentData.hasequipmenttype &&
              equipmentData.hasequipmenttype[0]?.equipmenttype
                ?.isequipmenttypeof !== undefined
                ? equipmentData?.hasequipmenttype &&
                  equipmentData.hasequipmenttype[0].equipmenttype
                    .isequipmenttypeof[0].brand.name
                : ""}{" "}
              {equipmentData?.hasequipmenttype &&
                equipmentData.hasequipmenttype[0].equipmenttype.model}{" "}
              <br />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

MachineCardItem2.defaultProps = {
  data: null,
  imageUrl: false,
  title: "",
};

export default MachineCardItem2;
